<style scoped src="../../../css/selector-base.less" lang="less"></style>
<style lang="less" scoped>
    .select-item-container{
        height: 160px;
        overflow: auto;
    }
</style>
<template>
    <div class="item-selector">
        <Poptip @on-popper-show="poperShow" placement="bottom" :width="width" :transfer="false">
            <i-button class="selector-btn" :class="{'type-text': type === 'text'}" :type="type" :size="size" long :disabled="disabled">
                <slot>
                    <span class="color-grey">选择...</span>
                </slot>
                <Icon class="cancel-btn" @click.stop="setItem({id: 0})" type="ios-close-circle" v-if="clearable"></Icon>
            </i-button>
            <div class="pop-tip-content" v-show="!disabled" slot="content">
                <i-input class="search-area" v-model="params.search" @on-search="getItems" search placeholder="搜索..."></i-input>
                <Spin fix v-if="loading"></Spin>
                <div class="select-item-container">
                    <div class="select-item"
                         :class="{'select-item-disabled': item.id === value}"
                         @click="setItem(item)"
                         v-for="item in items"
                         :key="item.id">
                        <span>{{item.uid}} - {{item.name}} - {{item.payee_company || '未设置合同签署方'}}</span>
                    </div>
                </div>
            </div>
        </Poptip>
    </div>
</template>
<script>
    export default {
        props: {
            value: {
                type: Number
            },
            type: {
                type: String
            },
            size: {
                type: String
            },
            width: {
                type: [Number, String],
                default: 400
            },
            disabled: {
                type: Boolean,
                default: false
            },
            clearable: {
                type: Boolean,
                default: true
            },
            url: {
                type: String,
                default: Util.api.contract_select_search
            }
        },
        data(){
            return {
                params: {
                    search: ''
                },
                items: [],
                loading: false
            }
        },
        computed: {
            //
        },
        created(){
            //
        },
        mounted(){
            //
        },
        methods: {
            poperShow(){
                if(this.items.length === 0){
                    this.getItems();
                }
            },
            getItems(){
                if(this.loading) return;
                this.loading = true;
                Util.ajax.get(this.url, {
                    params: this.params
                }).then((response)=>{
                    return response.data;
                }).then((res)=>{
                    if(res.code === 1){
                        let data = res.data;
                        this.items = data.contracts;
                    }else{
                        this.$Modal.error({title: '提示', content: res.msg});
                    }
                }).catch((e)=>{
                    this.$Modal.error({title: '提示', content: e.message});
                }).finally(()=>{
                    this.loading = false;
                });
            },
            setItem(item){
                this.$emit('input', item.id);
                this.$emit('on-change', item);
                document.body.click();
            }
        }
    }
</script>
